import {
  FaArrowCircleRight,
  FaArrowUp,
  FaAward,
  FaBan,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarDay,
  FaCheck,
  FaCheckCircle,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaClock,
  FaClone,
  FaCog,
  FaEnvelope,
  FaExclamationTriangle,
  FaEye,
  FaFilter,
  FaGraduationCap,
  FaHorseHead,
  FaInfoCircle,
  FaLink,
  FaList,
  FaLocationArrow,
  FaPencilAlt,
  FaPhone,
  FaPlus,
  FaSave,
  FaShoppingBasket,
  FaSpinner,
  FaTag,
  FaTimes,
  FaTrash,
  FaUser,
  FaUserGraduate,
  FaUsers,
  FaLock,
  FaArrowDown,
  FaChartBar,
  FaBars, // ✨ NOUVEAU
  FaSignOutAlt,
  FaFileImport,
  FaFileExport,
  FaFile,
} from 'react-icons/fa';
import { FaBoltLightning } from 'react-icons/fa6';

export const Icons = {
  Add: FaPlus,
  Award: FaAward,
  Blocked: FaBan,
  Calendar: FaCalendarAlt,
  Cancel: FaBan,
  Check: FaCheck,
  CheckCircle: FaCheckCircle,
  ChevronDown: FaChevronDown,
  ChevronLeft: FaChevronLeft,
  ChevronRight: FaChevronRight,
  Clock: FaClock,
  Close: FaTimes,
  Competition: FaAward,
  Date: FaCalendar,
  Delete: FaTrash,
  Edit: FaPencilAlt,
  Email: FaEnvelope,
  Event: FaCalendarDay,
  Filter: FaFilter,
  GroupLesson: FaUsers,
  Horse: FaHorseHead,
  Info: FaInfoCircle,
  Lesson: FaGraduationCap,
  Link: FaLink,
  List: FaList,
  Loading: FaSpinner,
  Location: FaLocationArrow,
  Packages: FaShoppingBasket,
  Phone: FaPhone,
  PrivateLesson: FaUserGraduate,
  Remove: FaArrowUp,
  Repeat: FaArrowCircleRight,
  Save: FaSave,
  Service: FaShoppingBasket,
  Settings: FaCog,
  Tag: FaTag,
  Template: FaClone,
  Training: FaGraduationCap,
  User: FaUser,
  Users: FaUsers,
  View: FaEye,
  Warning: FaExclamationTriangle,
  Lock: FaLock,
  ArrowDown: FaArrowDown,
  BarChart: FaChartBar,
  Menu: FaBars,
  X: FaTimes, // (alias de Close)
  LogOut: FaSignOutAlt,
  Import: FaFileImport,
  Export: FaFileExport,
  File: FaFile,
  ChangeLog: FaBoltLightning,
};

export const renderIcon = (Icon, props = {}) => {
  return <Icon {...props} />;
};

export default Icons;
